import { getAuthOS } from "@/utils/getAuthOS";
import { useEffect } from "react";
import { useAuth } from "@akina/infra";
import { AppRoutes } from "@/infra/router";

export function LoginPage() {
    const { loginWithRedirect } = useAuth();

    useEffect(() => {
        const login = async () => {
            const os = await getAuthOS();
            loginWithRedirect({ returnTo: AppRoutes.Dashboard }, "", os);
        };
        login();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
}